import { render, staticRenderFns } from "./terms_romania.vue?vue&type=template&id=3d50dc98&scoped=true&"
import script from "./terms_romania.vue?vue&type=script&lang=js&"
export * from "./terms_romania.vue?vue&type=script&lang=js&"
import style0 from "./terms_romania.vue?vue&type=style&index=0&id=3d50dc98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d50dc98",
  null
  
)

export default component.exports